/**
 * A DOM id for one tree's row in the schedule, so a pin on the map can point at
 * it.
 *
 * A tree is identified by its site AND its label, because labels repeat across
 * sites, so both go in. Every character that is not a letter or digit is
 * spelled out as its code, underscores included, which makes the encoding
 * reversible and so collision-free: "A.1" and "A-1" are different trees and
 * must not share an id, and the first of two duplicate ids would silently win.
 */
export function scheduleRowId(siteName: string, label: string): string {
  const encode = (text: string): string =>
    text.replace(
      /[^A-Za-z0-9]/g,
      (character) => `_${(character.codePointAt(0) ?? 0).toString(16)}_`,
    )
  return `tree-${encode(siteName)}-${encode(label)}`
}
